import React, { useState } from 'react';
import { NtIcon } from '../NotionUI';
import { useLanguage } from '../../i18n/LanguageContext';

export const VIEW_ICONS = { table: 'table', board: 'board', gantt: 'clock', calendar: 'calendar', list: 'list', gallery: 'layout' };
export const VIEW_TYPES = ['table', 'board', 'list', 'gallery', 'gantt', 'calendar'];

/**
 * Schede delle viste salvate di un progetto: selezione, creazione di una nuova
 * vista (per tipo) e, sulla scheda attiva, rinomina / duplica / elimina.
 */
function ProjectViewTabs({ views, activeId, onSelect, onCreate, onRename, onDuplicate, onDelete }) {
  const { t } = useLanguage();
  const [menu, setMenu] = useState(null); // 'new' oppure id vista
  const [name, setName] = useState('');

  const close = () => setMenu(null);

  return (
    <div className="nt-tabs-list pv-tabs" role="tablist">
      {views.map((view) => (
        <span key={view.id} className="pv-tab-wrap">
          <button
            type="button"
            role="tab"
            aria-selected={activeId === view.id}
            className={`nt-tab${activeId === view.id ? ' nt-tab-active' : ''}`}
            onClick={() => (activeId === view.id ? (setName(view.name), setMenu(view.id)) : onSelect(view.id))}
            title={activeId === view.id ? t('projectView.viewOptions') : undefined}
          >
            <NtIcon name={VIEW_ICONS[view.type] || 'table'} size={15} />
            {view.name}
          </button>
          {menu === view.id && (
            <>
              <div className="pd-overlay" onClick={close} />
              <div className="pd-popover pv-menu">
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    if (name.trim() && name.trim() !== view.name) onRename(view, name.trim());
                    close();
                  }}
                >
                  <input autoFocus value={name} maxLength={60} onChange={(e) => setName(e.target.value)} aria-label={t('projectView.viewName')} />
                </form>
                <button type="button" className="pv-menu-item" onClick={() => { close(); onDuplicate(view); }}>
                  <NtIcon name="copy" /> {t('projectView.duplicateView')}
                </button>
                <button type="button" className="pv-menu-item" disabled={views.length <= 1} onClick={() => { close(); onDelete(view); }}>
                  <NtIcon name="trash" /> {t('projectView.deleteView')}
                </button>
              </div>
            </>
          )}
        </span>
      ))}
      <span className="pv-tab-wrap">
        <button type="button" className="nt-tab pv-add-tab" onClick={() => setMenu('new')} aria-label={t('projectView.addView')} title={t('projectView.addView')}>
          <NtIcon name="plus" size={15} />
        </button>
        {menu === 'new' && (
          <>
            <div className="pd-overlay" onClick={close} />
            <div className="pd-popover pv-menu">
              <div className="pd-popover-label">{t('projectView.newView')}</div>
              {VIEW_TYPES.map((type) => (
                <button key={type} type="button" className="pv-menu-item" onClick={() => { close(); onCreate(type); }}>
                  <NtIcon name={VIEW_ICONS[type]} /> {t(`projectView.type_${type}`)}
                </button>
              ))}
            </div>
          </>
        )}
      </span>
    </div>
  );
}

export default ProjectViewTabs;
